module.exports = __webpack_public_path__ + "media/store/images/arrowColor-42a8ca621f87804d2ea357a6588a9f31.svg";